import React from "react"

import "./src/styles/index.scss"
import { GlobalProvider } from "./src/context/GlobalContext"

export const wrapRootElement = ({ element }) => <GlobalProvider>{element}</GlobalProvider>
